var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.visible,
            width: _vm.width,
            "append-to-body": "",
            modal: "",
          },
          on: { close: _vm.handleCloes },
        },
        [
          _c("BjDivider", [_vm._v(_vm._s(_vm.$t("screenWMS.detail")))]),
          _c("BjPage", {
            ref: "BjPageTop",
            attrs: {
              "get-action": _vm.queryApiTop,
              "query-params": _vm.queryParamsTop,
              "col-span": _vm.colSpan,
              "search-btn-span": _vm.colSpan,
              serial: _vm.serial,
              "search-btn-hide": true,
              "before-reset-search": _vm.beforeResetSearch,
              height: 217,
            },
            on: { afterFetchOriginalData: _vm.afterFetchOriginalData },
            scopedSlots: _vm._u([
              {
                key: "tableColumn",
                fn: function () {
                  return [
                    _vm._l(_vm.labelListTop, function (col, index) {
                      return [
                        col.prop !== "bjTableAction"
                          ? _c("el-table-column", {
                              key:
                                "col_" +
                                index +
                                "_" +
                                col.prop +
                                "_" +
                                (col.width || "auto"),
                              attrs: {
                                prop: col.prop,
                                label: col.label,
                                width: col.width || "auto",
                                fixed: col.fixed || false,
                                align: "center",
                                "class-name": "item",
                                "show-overflow-tooltip":
                                  col.prop !== "bjTableAction",
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        false
                                          ? void 0
                                          : col.prop === "dataStatus"
                                          ? [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.$t(
                                                      _vm.IMPORT_STATUS.bjGet(
                                                        scope.row.dataStatus
                                                      )
                                                    )
                                                  ) +
                                                  " "
                                              ),
                                            ]
                                          : _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm._f("timeFilters")(
                                                    scope.row[col.prop],
                                                    scope.row[col.prop]
                                                  )
                                                )
                                              ),
                                            ]),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                true
                              ),
                            })
                          : _vm._e(),
                      ]
                    }),
                  ]
                },
                proxy: true,
              },
            ]),
          }),
          _c("BjDivider", [_vm._v(_vm._s(_vm.$t("screenWMS.log")))]),
          _c("BjPage", {
            ref: "BjPageBottom",
            staticStyle: { "margin-bottom": "20px" },
            attrs: {
              "get-action": _vm.queryApiBottom,
              "query-params": _vm.queryParamsBottom,
              "col-span": _vm.colSpan,
              "search-btn-span": _vm.colSpan,
              serial: _vm.serial,
              "search-btn-hide": true,
              "before-reset-search": _vm.beforeResetSearch,
              height: 217,
            },
            on: { afterFetchOriginalData: _vm.afterFetchOriginalData },
            scopedSlots: _vm._u([
              {
                key: "tableColumn",
                fn: function () {
                  return [
                    _vm._l(_vm.labelListBottom, function (col, index) {
                      return [
                        col.prop !== "bjTableAction"
                          ? _c("el-table-column", {
                              key:
                                "col_" +
                                index +
                                "_" +
                                col.prop +
                                "_" +
                                (col.width || "auto"),
                              attrs: {
                                prop: col.prop,
                                label: col.label,
                                width: col.width || "auto",
                                fixed: col.fixed || false,
                                align: "center",
                                "class-name": "item",
                                "show-overflow-tooltip":
                                  col.prop !== "bjTableAction",
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        false
                                          ? void 0
                                          : col.prop === "dataStatus"
                                          ? [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.$t(
                                                      _vm.IMPORT_STATUS.bjGet(
                                                        scope.row.dataStatus
                                                      )
                                                    )
                                                  ) +
                                                  " "
                                              ),
                                            ]
                                          : _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm._f("timeFilters")(
                                                    scope.row[col.prop],
                                                    scope.row[col.prop]
                                                  )
                                                )
                                              ),
                                            ]),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                true
                              ),
                            })
                          : _vm._e(),
                      ]
                    }),
                  ]
                },
                proxy: true,
              },
            ]),
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }